/**
 * HTTP header constants for correlation and tracing.
 */

/**
 * Header name for correlation ID.
 * Must match backend expectation: 'x-correlation-id'
 */
export const CORRELATION_ID_HEADER = 'X-Correlation-ID';

/**
 * Alternative request ID header (some systems use this)
 */
export const REQUEST_ID_HEADER = 'X-Request-ID';
